<div class="relative flex min-h-screen items-center justify-center overflow-y-hidden">
  <!-- Ellipse Decoration -->
  <div class="bg-ellipse"></div>
  <div class="mx-auto">
    <app-login-component />
  </div>
</div>
